export const checkIsNan = (value: any): number => {
  const num = Number(value);
  if (Number.isNaN(num)) return 0;
  return num;
};
